var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrackets = function SvgBrackets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 411,
    viewBox: "0 0 31 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C7.31893 1 13.2656 6.98325 13.2656 14.3902V191.964C13.2656 199.351 19.1931 205.354 26.5311 205.354H30.0191",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 409.689C7.31893 409.689 13.2656 403.705 13.2656 396.299V218.725C13.2656 211.337 19.1931 205.335 26.5311 205.335H30.0191",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgBrackets;